import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureDeveloperEnabled } from '@/features/developers/guard.js';

/** Legacy `/developers/spending` — moved to `/developer/spending`. */
export const Route = createFileRoute('/developers/spending')({
  beforeLoad: async () => {
    await ensureDeveloperEnabled();
    throw redirect({ to: '/developer/spending', replace: true });
  },
});
